import PluginAction from '../PluginAction';

export default class Plugin extends PluginAction {}
